/* eslint-disable camelcase */
import * as THREE from 'three'
import { createRectsMeshes } from '../utils/helper_functions'
import { drawLabel } from './drawLabel'
import { textGeometries, materials } from '../utils/mapData'
import { getGeometryArray } from '../utils/getGeometryArray'

export const drawMultipleRects = (group, options) => {
  const { x, y, labelPositions } = group
  const {
    color,
    scale,
    materialGroup,
    scene,
    seat_circle_radius,
    fonts,
    center_x,
    center_y,
    opacity = 1
  } = options

  const { rectMeshes, ring } = createRectsMeshes(group.rects, options)

  const drawMultipleRects = () => {
    const lineBasicMaterial = new THREE.LineBasicMaterial({
      color,
      opacity,
      transparent: true
    })

    ring.borderLines = rectMeshes.map(({ geometry, position }) => {
      const lineGeometry = new THREE.BufferGeometry()
      const geometryArray = getGeometryArray(geometry)
      const vertices = new Float32Array(geometryArray)

      lineGeometry.setAttribute(
        'position',
        new THREE.BufferAttribute(vertices, 3)
      )
      const line = new THREE.Line(lineGeometry, lineBasicMaterial)
      line.position.set(x * scale + position.x, -y * scale + position.y, 0)
      ring.add(line)
      return line
    })
  }

  drawMultipleRects()

  if (!group.hideSectionLabel && labelPositions) {
    const labelText = materialGroup.label

    labelPositions.forEach(({ x, y, rotation = 0 }) => {
      drawLabel(
        labelText,
        {
          font: fonts.openSans,
          color: 'black',
          position: [x * scale, -y * scale, 0],
          center_x,
          center_y,
          scale,
          seat_circle_radius,
          scene,
          size: group.size || 15,
          rotation
        },
        textGeometries,
        materials
      )
    })
  }

  return { standingArea: ring, rectMeshes }
}
